// extracted by mini-css-extract-plugin
export default {"choice":"choice_choice__DGdf2","choiceValue":"choice_choiceValue__WOZyO","choiceExplanation":"choice_choiceExplanation__6Gxlg","fullWidth":"choice_fullWidth__K7-25"};